import React from 'react';
import visaCard from '../../../../../../assets/image/subscription/visa-icon.svg';

const getCardIcon = (network) => {
	if (!network) return visaCard;
	const n = network.toLowerCase();
	if (n.includes('mastercard')) return visaCard;
	if (n.includes('visa')) return visaCard;
	return visaCard; // default
};

export default function SubscriptionBankCard({ card, onDelete }) {
	return (
		<div className="subscription-bank-card p-4 m-2 rounded-4">
			<div className="d-flex justify-content-between align-items-end">
				<div>
					<div className="fs-3 fw-bold text-dark py-1">{card.network ?? 'Card'}</div>
					<div className="fs-4 fw-semibold text-dark py-1">
						{card.last4 ? `**** **** **** ${card.last4}` : '-'}
					</div>
					<div className="fs-5 fw-light text-dark py-1">
						{card.expiry_month && card.expiry_year
							? `Expiring ${card.expiry_month}/${card.expiry_year}`
							: '-'}
					</div>
					{card.card_name && <div className="fs-5 fw-light text-dark py-1">{card.card_name}</div>}
				</div>

				<div className="d-flex flex-column align-items-end gap-2">
					<img
						width={40}
						height={40}
						src={getCardIcon(card.network)}
						alt={card.network ?? 'card'}
					/>
					<div
						className="p-1 fs-5 fw-light rounded-4"
						style={{ color: card.is_default ? '#68C230' : '#6c757d' }}
					>
						{card.is_default ? 'Default' : 'Saved'}
					</div>

					{onDelete && (
						<div
							className="fs-5 fw-light cursor-pointer"
							style={{ color: '#dc3545', textDecorationLine: 'underline' }}
							onClick={() => onDelete(card.token_id)}
						>
							Remove
						</div>
					)}
				</div>
			</div>
		</div>
	);
}
